import { atom, useAtom } from 'jotai';
import {IntentEnum} from "../enums/IntentEnum";

// bool for toggling the side FAQ
export const selectedTabAtom = atom(IntentEnum.FreeQuestion);

export function useSelectedTabAtom() {
  return useAtom(selectedTabAtom);
}
